import Swiper, { Navigation } from "swiper";

window.addEventListener( "DOMContentLoaded", ( event ) => {
	const swipers = document.querySelectorAll( ".petrebels-kiyoh-slider" );

	swipers.forEach( function( element ) {
		new Swiper( element.querySelector('.swiper'), {
			modules: [ Navigation ],
			navigation: {
				enabled: true,
				nextEl: element.querySelector(".swiper-button-next"),
				prevEl: element.querySelector(".swiper-button-prev"),
			},
			spaceBetween: 20,
			slidesPerView: 1,
			breakpoints: {
				1900: {
					slidesPerView: 6,
				},
				1200: {
					slidesPerView: 5,
				},
				1000: {
					slidesPerView: 4,
				},
				800: {
					slidesPerView: 3,
				},
				600: {
					slidesPerView: 2,
				},
			}
		} );
	} );
});
